import { BidStatus, SourcingEventStatus } from "../../autogen/bff-api";

export type BidOutcome =
  | "draft"
  | "notDelivered"
  | "submitted"
  | "awarded"
  | "notSelected"
  | "rejected";

const AWARD_DECIDED_EVENT_STATUSES: SourcingEventStatus[] = [
  SourcingEventStatus.AwardDecision,
  SourcingEventStatus.Awarded,
];

export const isEventAwarded = (
  eventStatus: SourcingEventStatus | undefined,
): boolean =>
  eventStatus != null && AWARD_DECIDED_EVENT_STATUSES.includes(eventStatus);

export const isAwardDecided = (
  bids: { status: BidStatus }[] | undefined,
): boolean => bids?.some((b) => b.status === BidStatus.Awarded) ?? false;

export const deriveBidOutcome = (
  bidStatus: BidStatus,
  awardDecided: boolean,
  biddingClosed = false,
): BidOutcome => {
  if (bidStatus === BidStatus.Rejected) return "rejected";
  if (bidStatus === BidStatus.Awarded) return "awarded";
  if (bidStatus === BidStatus.Draft) return biddingClosed ? "notDelivered" : "draft";
  return awardDecided ? "notSelected" : "submitted";
};
